module.exports = __webpack_public_path__ + "static/media/Facebook4.1704f219.png";